import { useEffect, useMemo, useState } from "react";
import { ArrowPathIcon, ExclamationTriangleIcon } from "@heroicons/react/20/solid";
import { PHASES_COLORS, PHASES_TEXTS } from "../../../services/live-interface/lca-interface-service";
import { formatSecondsToMinutesSeconds } from "../../../helpers/date/date-helper";


export const Timeline = ({ pattern, phases, phaseErrorIndex, isLive }) => {
  // const [phases, setPhases] = useState([]);
  const startDate = phases.length > 0 ? phases[0].start_date : null;
  const patternDuration = pattern?.pattern_phases?.length > 0 ?
    pattern.pattern_phases[pattern.pattern_phases.length - 1].end_date - pattern.pattern_phases[0].start_date : 0;
  const liveDuration = phases.length > 0 ? phases[phases.length - 1].end_date - phases[0].start_date : 0;
  const displayDuration = Math.max(patternDuration, liveDuration);

  const ticksNumber = Math.min(Math.ceil(displayDuration / 30), 10);
  const tickInterval = displayDuration / ticksNumber;

  return (
    <div className="h-full flex mr-4">
      <div className="h-full flex flex-col">
        <div className="h-1/3 p-2 mt-5 flex items-center justify-end">
          <span className="inline-flex items-center rounded-md select-none bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10">Modèle</span>
        </div>
        <div className="h-2/3 p-2 flex items-center justify-end">
          <style>{`
            @keyframes bounceScale {
              0%, 100% {
                transform: scale(1);
              }
              50% {
                transform: scale(1.15);
              }
            }
          `}</style>
          {isLive && <ArrowPathIcon className="animate-spin w-5 h-5 text-perception-blue mr-1"/>}
          <span className="inline-flex items-center rounded-md select-none bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10">Live</span>
        </div>
      </div>
      <div className="h-full w-full flex flex-col gap-1">

        {/* Ticks */}
        <div className="relative h-4">
          {Array.from({ length: ticksNumber + 1 }).map((_, tickIndex) => {
            const tickTime = tickIndex * tickInterval;
            const tickPosition = (tickTime / displayDuration) * 100;
            const halfTickPosition = (tickTime + tickInterval / 2) / displayDuration * 100;

            return (
              <div key={tickIndex} className='inline-block select-none' style={{ width: `${100 / ticksNumber}%` }}>
                {/* TICK */}
                <div className="absolute border-l border-gray-400" style={{ height: "10px", left: `${tickPosition}%`, top: "5px" }}/>

                {/* HALF TICK */}
                {halfTickPosition <= 100 && (
                  <div className="absolute border-l border-gray-400" style={{height: "5px", left: `${halfTickPosition}%`, top: "5px"}}/>
                )}

                {/* TIME */}
                <div className='text-xs text-perception-gray-600' style={{ position: 'absolute', left: `${tickPosition}%`, top: '-20px', transform: 'translateX(-50%)' }}>
                  {formatSecondsToMinutesSeconds(tickTime)}
                </div>
              </div>
            );
          })}
        </div>

        {/* Model timeline */}
        <div className="bg-gray-200 h-1/3 relative rounded-md">
          {
            pattern.pattern_phases.map((phase, index) => {
              if (phase.type <= 0) return null;

              const barPosition = phase.start_date / displayDuration * 100;
              const barWidth = (phase.end_date - phase.start_date) / displayDuration * 100;
              const barColor = PHASES_COLORS[phase.type];
              const barText = PHASES_TEXTS[phase.type];

              return (
                <div className="h-full absolute py-1 z-5" style={{ left: `${barPosition}%`, width: `${barWidth}%` }} key={index}>
                  <div className={`h-full ${barColor} truncate select-none rounded-md flex items-center p-2 text-sm text-white`}>{barText}</div>
                </div>
              );
            })
          }
        </div>

        {/* Live timeline */}
        <div className="bg-gray-200 h-2/3 relative rounded-md">
          {
            phases.filter((phase) => phase.type > 0).map((phase, index) => {
              if (phase.type <= 0) return null;

              const isError = index === phaseErrorIndex;
              const barPosition = (phase.start_date - startDate) / displayDuration * 100;
              const barWidth = (phase.end_date - phase.start_date) / displayDuration * 100;
              const barColor = isError ? PHASES_COLORS['error'] : PHASES_COLORS[phase.type];
              const barText = PHASES_TEXTS[phase.type];

              return (
                <div className="h-full absolute py-1 z-5" style={{ left: `${barPosition}%`, width: `${barWidth}%` }} key={index}>
                  <div className={`h-full ${barColor} truncate select-none rounded-md flex items-center p-2 text-sm text-white`}>
                    {
                      isError && <ExclamationTriangleIcon className="w-6 h-6 min-w-6 min-h-6 mr-2 text-yellow-200"/>
                    }
                    {barText}
                  </div>
                </div>
              );
            })
          }
        </div>
      </div>
    </div>
  );
};